import './js/transition.js';
import './js/alert.js';
import './js/button.js';
import './js/carousel.js';
import './js/collapse.js';
import './js/dropdown.js';
import './js/modal.js';
import './js/tooltip.js';
import './js/popover.js';
import './js/scrollspy.js';
import './js/tab.js';
import './js/affix.js';
import './js/bootstrap.js'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/styles/bootstrap/bootstrap.ts